<template>
   <!-- <AppLayout title="Admins"> -->
        
        
        <v-card class="d-flex flex-column flex-grow-1 table-card overflow-visible" :class="tableCard.card.class" :rounded="tableCard.card.rounded">
            <v-card-text class="d-flex flex-column flex-grow-1" :class="tableCard.card.textClass">
                <div class="d-flex align-center ga-3 px-3 px-md-0" :class="[tableCard.card.actionPad]">
                    <div class="d-flex flex-grow-1 min-w-0">
                        <div class="w-100 w-sm-20rem max-w-100">
                            <v-text-field
                                v-model="datatable.request.search.value"
                                :label="tableCard.searchInput.label"
                                :placeholder="tableCard.searchInput.placeholder"
                                :density="tableCard.searchInput.density"
                                :flat="tableCard.searchInput.flat"
                                :variant="tableCard.searchInput.variant"
                                :single-line="tableCard.searchInput.singleLine"
                                :hide-details="true"
                                @update:model-value="() => datatable.onSearch()"
                                clearable
                                :class="[`table-action`, tableCard.searchInput.class]"
                            >
                            <template #prepend-inner >
                                <span >
                                    <mdi-icon>search</mdi-icon>
                                </span>
                            </template>
                            </v-text-field>
                        </div>
                    </div>
                    <div class="d-flex justify-end">
                        <div class="d-none d-sm-block">
                            <Link :href="route('admins.manage')">
                                <v-btn-input-compact text="Create Admin" class="table-action">
                                    <template #prepend>
                                        <mdi-icon>add</mdi-icon>
                                    </template>
                                </v-btn-input-compact>
                            </Link>
                        </div>
                        <div class="d-sm-none">
                            <v-btn-icon :color="tableCard.actionMenu.btn.color"  class="match-input-compact table-action" :variant="tableCard.actionMenu.btn.variant">
                                <mdi-icon :size="tableCard.actionMenu.btn.iconSize">{{ tableCard.actionMenu.btn.icon }}</mdi-icon>

                                <v-menu activator="parent" class="tiny-dropdown">
                                    <v-list>
                                        <Link class="v-list-item-n-link" :href="route('admins.manage')">
                                            <v-list-item title="Create Admin" value="create_admin">
                                                <template #prepend>
                                                    <mdi-icon>add</mdi-icon>
                                                </template>
                                            </v-list-item>
                                        </Link>
                                    </v-list>
                                </v-menu>
                            </v-btn-icon>
                        </div>
                    </div>
                </div>
                <div class="d-flex-col-grow">
                    <DataTable :datatable="datatable" class="d-flex flex-column has-action"  >
                        <template v-slot:[`item.biller`]="{ item }" key="item.biller">
                            <div>{{ item.biller }}</div>
                        </template>
                        <template v-slot:[`item.bankAccount`]="{ item }" key="item.bankAccount">
                            <div>{{ item.bankAccount }}</div>
                        </template>
                        <template v-slot:[`item.action`]="{ item }" key="item.action">
                            <div>
                                <div class="d-none d-md-block">
                                    <div class="d-flex justify-center">
                                        <v-tooltip text="Edit">
                                            <template v-slot:activator="{ props }">
                                                <Link :href="route('admins.manage', item.id)" v-bind="props">
                                                    <v-btn-icon-text color="primary">
                                                        <mdi-icon>edit_square</mdi-icon>
                                                    </v-btn-icon-text>
                                                </Link>
                                            </template>
                                        </v-tooltip>
                                        
                                        <v-btn-icon-text color="danger" @click="confirmUserDeletion(item)">
                                            <mdi-icon>delete</mdi-icon>
                                        </v-btn-icon-text>
                                    </div>
                                </div>
                                <div class="d-md-none">
                                    <v-btn-icon :color="tableCard.actionMenu.btn.color" density="compact" variant="plain">
                                        <mdi-icon>{{ tableCard.actionMenu.btn.icon }}</mdi-icon>

                                        <v-menu activator="parent" class="tiny-dropdown">
                                            <v-list min-width="120px">
                                                <Link class="v-list-item-n-link" :href="route('admins.manage', item.id)">
                                                    <v-list-item title="Edit" value="edit_admin">
                                                        <template #prepend>
                                                            <mdi-icon>edit_square</mdi-icon>
                                                        </template>
                                                    </v-list-item>
                                                </Link>
                                                <v-list-item title="Delete" color="danger" value="delete_admin" @click="confirmUserDeletion(item)">
                                                        <template #prepend>
                                                            <mdi-icon>delete</mdi-icon>
                                                        </template>
                                                    </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </v-btn-icon>
                                </div>
                            </div>
                            
                        </template>
                    </DataTable>
                </div>
                
                
            </v-card-text>
        </v-card>
        <!-- API Token delete confirm Modal -->
        <v-dialog v-model="deletingUser" width="auto" @afterLeave="deletingUser = false">
            <v-card max-width="100%" width="500">
                <v-card-title>Delete Admin</v-card-title>
                <v-card-subtitle>Are you sure you want to delete this Admin?</v-card-subtitle>
                <v-card-text class="py-2">
                    <div v-if="deleteUserForm.errors.custom_error" class="text-error">{{ deleteUserForm.errors.custom_error }}</div>
                </v-card-text>
                <v-card-actions-modal>
                    <v-btn
                        text="Cancel"
                        color="btn-secondary"
                        @click="deletingUser = false"
                    ></v-btn>
                    <v-btn
                        :disabled="deleteUserForm.processing"
                        :loading="deleteUserForm.processing"
                        @click="deleteUser"
                        color="error"
                        text="Delete"
                    ></v-btn>
                </v-card-actions-modal>
            </v-card>
        </v-dialog>
        <ManageBin v-model="manageBinDialog" :child="manageBinUser" />
   <!-- </AppLayout> -->
</template>
<script setup lang="ts">
    import { ref } from "vue";
    import { Page, GlobalEventCallback } from '@inertiajs/core';
    import { usePage, Link, useForm } from '@inertiajs/vue3';
    import AppLayout from '@/Layouts/AppLayout.vue';
    import { SharedPageProps } from '@/Types/inertia';
    import { User } from '@/Types/Models/user';
    import { useDatatable } from '@/Composables/Datatable';
    import { toast } from "vue3-toastify";
    import { pageTitle, useTableCard, containerGapForTable } from '@/Composables/PageMeta';
    import DataTable from '@/Components/vuetify/DataTable.vue';
    import ManageBin from '@/Pages/Users/ManageBin.vue';

    containerGapForTable();
    type PageData = SharedPageProps & {
        data:{
            table?: {
                datatable: any,
                columns: any
            };
        };
    }
    const page = usePage<PageData>();
    pageTitle.value = 'Admins';
    const datatable = useDatatable(route('admins.index'), page.props.data.table);
    console.log(datatable.request.length)

    const deleteUserForm = useForm({
        custom_error: ''
    });
    const deletingUser = ref(false);
    const userBeingDeleted = ref<any>();
    const confirmUserDeletion = async (user: any) => {
        deleteUserForm.reset();
        deleteUserForm.clearErrors();
        userBeingDeleted.value = user;
        deletingUser.value = true;
    };

    const deleteUser = () => {
        deleteUserForm.delete(route('admins.delete', userBeingDeleted.value.id), {
            preserveScroll: true,
            onSuccess: ((page: Page<PageData>) => {
                deleteUserForm.reset();
                userBeingDeleted.value = null;
                deletingUser.value = false;
                toast.success(page.props.jetstream?.flash?.msg?.text ?? 'Admin is deleted');
                datatable.setTable(page.props.data.table);
            }) as GlobalEventCallback<"success">,
        });
    };

    const tableCard = useTableCard();

    const manageBinDialog = ref(false);
    const manageBinUser = ref<number>(0);
    const openManageBinDialog = (item: User) => {
        manageBinDialog.value = true;
        manageBinUser.value = item.id ?? 0;
    }
</script>